import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=6381171e&scoped=true&"
import script from "./project-list.vue?vue&type=script&lang=ts&"
export * from "./project-list.vue?vue&type=script&lang=ts&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=6381171e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6381171e",
  null
  
)

export default component.exports